"use client";
import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { ModuleSettingsStore } from "../../../../utils/contentstack/moduleSettingsStore.js";
import { MODULE_SETTINGS_WAREHOUSES_PAGE_URL, MODULE_SETTINGS_WAREHOUSES_PAGE_URL_SUFFIX } from "../../../../utils/warehouses/constants.js";
import { getWarehouseDisplayName } from "../../../../utils/warehouses/getWarehouseDisplayName.js";
import { getWarehouseUrl } from "../../../../utils/warehouses/getWarehouseUrl.js";
import { hasGas, hasRegularGasPrice, hasPremiumGasPrice, hasDieselGasPrice, hasZeroEthanolGasPrice, hasSupportedServices, capitalizeFirstLetter, hasCarWash, hasTires, hasBusiness, hasFood, hasHearing, hasOptical, hasPharmacy, getDirections } from "../../../../utils/warehouses/warehouseHelpers.js";
import { useRef, useEffect, useState, useCallback } from "react";
import { useTracking } from "react-tracking";
import { AccordionSummary, AccordionDetails, Box } from "@mui/material";
import { Text, Link, ListItem, Button, Notification } from "@nxt-costco-com/forge-components";
import { SpaceSm, SpaceXl, SpaceXs, FontLineHeightMd, SpaceMd, ColorTextDefault, SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
import { CarWash } from "@nxt-costco-com/forge-icons/icons/CarWash";
import { CheckmarkCircle } from "@nxt-costco-com/forge-icons/icons/CheckmarkCircle";
import { FoodCourt } from "@nxt-costco-com/forge-icons/icons/FoodCourt";
import { Gas } from "@nxt-costco-com/forge-icons/icons/Gas";
import { HearingAids } from "@nxt-costco-com/forge-icons/icons/HearingAids";
import { Location } from "@nxt-costco-com/forge-icons/icons/Location";
import { Optical } from "@nxt-costco-com/forge-icons/icons/Optical";
import { Pharmacy } from "@nxt-costco-com/forge-icons/icons/Pharmacy";
import { Tires } from "@nxt-costco-com/forge-icons/icons/Tires";
import { Truck } from "@nxt-costco-com/forge-icons/icons/Truck";
import { Analytics } from "../../../Analytics/index.js";
import { OpeningHours } from "../../OpeningHours/index.js";
import { StockStatus } from "../../StockStatus/index.js";
import { GasPrice } from "./GasPrice/index.js";
import { IS_SHOWROOM_LOCATION } from "../constants.js";
import { renderWarehousePin } from "../../WarehouseMap/lib.js";
import { useWarehousePinSelection } from "../../WarehouseMap/useWarehousePinSelection.js";
import { useCheckScreen } from "../../../../hooks/useCheckScreen/index.js";
import { ScheduledHours } from "./ScheduledHours/index.js";
import { SHOW_WAREHOUSE_DETAILS, HIDE_WAREHOUSE_DETAILS, PIN_SELECTION, SERVICES, GAS_PRICES, GAS_REGULAR, GAS_PREMIUM, GAS_DIESEL, GAS_ZERO_ETHANOL, HOURS, GET_DIRECTIONS, VIEW_STORE_PAGE, SET_WAREHOUSE_BUTTON_LABEL, MY_WAREHOUSE, GAS_STATION, TIRE_CENTER, FOOD_COURT, BUSINESS_CENTER, HEARING_AIDS, OPTICAL, PHARMACY, CAR_WASH, OPEN_HOLIDAY_LABEL, CLOSED_HOLIDAY_LABEL, BUSINESS_HOURS_LABEL, EXECUTIVE_MEMBER_LABEL, EXECUTIVE_MEMBER_HOURS_LABEL, SERVICE_ERROR_MESSAGE, BUSINESS_CENTER_LABEL, UNIQUE_ID_MY_WAREHOUSE_ICON, UNIQUE_ID_MY_WAREHOUSE_TEXT, UNIQUE_ID_MY_WAREHOUSE_PHONE } from "./constants.js";
import { getStockStatusProps } from "./utils/warehouseTile.lib.js";
import { Wrapper, MyWarehouse, NameAndDistanceAndLocation, LocationIconWrapper, NameAndDistance, Distance, SeeWarehouseDetails, AccordianSummarySx, StyledChevronDown, Subheader, GasList, Icons, listItemStyles, iconStyles } from "./styles.js";
const WarehouseTile = ({
  warehouseData,
  locale,
  onSetWarehouse,
  defaultDetailsExpanded,
  locationSearchParam,
  moduleSettings,
  isPreferredWarehouse,
  productFlags,
  featureFlags,
  showSetWarehouseButton,
  showPhoneNumber,
  isFullPage,
  warehouseNameRef,
  pinIndex,
  shouldFocusMyWarehouse,
  setShouldFocusMyWarehouse
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const { trackEvent } = useTracking();
  const msStore = new ModuleSettingsStore({
    composable_window: moduleSettings == null ? void 0 : moduleSettings.composable_window,
    key_value: moduleSettings == null ? void 0 : moduleSettings.key_value
  });
  const hideScheduledHours = (_a = moduleSettings == null ? void 0 : moduleSettings.properties[0]) == null ? void 0 : _a.hideScheduledHours;
  const enableModUrlPath = (_b = moduleSettings == null ? void 0 : moduleSettings.properties[0]) == null ? void 0 : _b.enableModUrlPath;
  const showWarehouseDetails = msStore.getKeyValueItem(
    SHOW_WAREHOUSE_DETAILS
  );
  const hideWarehouseDetails = msStore.getKeyValueItem(
    HIDE_WAREHOUSE_DETAILS
  );
  msStore.getKeyValueItem(PIN_SELECTION) || true;
  const services = msStore.getKeyValueItem(SERVICES);
  const gasPrices = msStore.getKeyValueItem(GAS_PRICES);
  const gasPriceRegular = msStore.getKeyValueItem(GAS_REGULAR);
  const gasPricePremium = msStore.getKeyValueItem(GAS_PREMIUM);
  const gasPriceDiesel = msStore.getKeyValueItem(GAS_DIESEL);
  const gasPriceZeroEthanol = msStore.getKeyValueItem(GAS_ZERO_ETHANOL);
  const hours = msStore.getKeyValueItem(HOURS);
  const getDirectionsLabel = msStore.getKeyValueItem(GET_DIRECTIONS);
  const viewStorePage = msStore.getKeyValueItem(VIEW_STORE_PAGE);
  const setWarehouseButtonLabel = msStore.getKeyValueItem(
    SET_WAREHOUSE_BUTTON_LABEL
  );
  const myWarehouse = msStore.getComposableWindowItem(MY_WAREHOUSE);
  const myWarehouseTitleRef = useRef(null);
  useEffect(() => {
    if (shouldFocusMyWarehouse && myWarehouseTitleRef.current) {
      setTimeout(() => {
        var _a2;
        (_a2 = myWarehouseTitleRef.current) == null ? void 0 : _a2.focus();
        setShouldFocusMyWarehouse == null ? void 0 : setShouldFocusMyWarehouse(false);
      }, 0);
    }
  }, [shouldFocusMyWarehouse, setShouldFocusMyWarehouse]);
  const gasStation = msStore.getKeyValueItem(GAS_STATION);
  const tireCenter = msStore.getKeyValueItem(TIRE_CENTER);
  const foodCourt = msStore.getKeyValueItem(FOOD_COURT);
  const businessCenter = msStore.getKeyValueItem(BUSINESS_CENTER);
  const hearingAids = msStore.getKeyValueItem(HEARING_AIDS);
  const optical = msStore.getKeyValueItem(OPTICAL);
  const pharmacy = msStore.getKeyValueItem(PHARMACY);
  const carWash = msStore.getKeyValueItem(CAR_WASH);
  const warehousesPageUrl = msStore.getKeyValueItem(
    MODULE_SETTINGS_WAREHOUSES_PAGE_URL
  );
  const warehousesPageUrlSuffix = msStore.getKeyValueItem(
    MODULE_SETTINGS_WAREHOUSES_PAGE_URL_SUFFIX
  );
  const openHolidayLabel = msStore.getKeyValueItem(OPEN_HOLIDAY_LABEL);
  const closedHolidayLabel = msStore.getKeyValueItem(CLOSED_HOLIDAY_LABEL);
  const businessHoursLabel = msStore.getKeyValueItem(BUSINESS_HOURS_LABEL);
  const executiveMemberLabel = msStore.getKeyValueItem(
    EXECUTIVE_MEMBER_LABEL
  );
  const executiveMemberHoursLabel = msStore.getComposableWindowItem(
    EXECUTIVE_MEMBER_HOURS_LABEL
  );
  const serviceErrorMessage = msStore.getComposableWindowItem(
    SERVICE_ERROR_MESSAGE
  );
  const businessCenterLabel = msStore.getKeyValueItem(BUSINESS_CENTER_LABEL);
  const { selectWarehouse } = useWarehousePinSelection();
  const warehouseName = getWarehouseDisplayName({
    businessCenterLabel,
    name: (_d = (_c = warehouseData == null ? void 0 : warehouseData.name) == null ? void 0 : _c[0]) == null ? void 0 : _d.value
  });
  const warehouseUrl = getWarehouseUrl({
    enableModUrlPath,
    locationSearchParam,
    warehouseData,
    warehousesPageBaseUrl: warehousesPageUrl,
    warehousesPageUrlSuffix
  });
  const [hasError, setHasError] = useState(false);
  const [isExpanded, setIsExpanded] = useState(
    defaultDetailsExpanded ?? false
  );
  const { isMobile } = useCheckScreen();
  const handleSetWarehouse = useCallback(() => {
    const success = onSetWarehouse();
    setHasError(!success);
    if (success) {
      setShouldFocusMyWarehouse == null ? void 0 : setShouldFocusMyWarehouse(true);
    }
  }, [onSetWarehouse, setShouldFocusMyWarehouse]);
  const handleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  const onClickHandler = () => {
    trackEvent({
      component: {
        trackedData: [
          isExpanded ? hideWarehouseDetails : showWarehouseDetails
        ]
      }
    });
  };
  const selectWarehousePin = (warehouseId) => {
    {
      selectWarehouse(warehouseId);
    }
  };
  return /* @__PURE__ */ jsxs(
    Wrapper,
    {
      isPreferredWarehouse,
      onClick: () => selectWarehousePin(warehouseData.warehouseId),
      children: [
        isPreferredWarehouse && /* @__PURE__ */ jsxs(MyWarehouse, { "data-testid": "warehousetile-mywarehouse", children: [
          /* @__PURE__ */ jsx(
            CheckmarkCircle,
            {
              sx: {
                height: "20px",
                marginRight: SpaceSm,
                width: "20px"
              },
              "data-testid": UNIQUE_ID_MY_WAREHOUSE_ICON
            }
          ),
          /* @__PURE__ */ jsx(
            Text,
            {
              bold: true,
              color: "success",
              component: isPreferredWarehouse && !isFullPage ? "h4" : "h3",
              uniqueId: UNIQUE_ID_MY_WAREHOUSE_TEXT,
              variant: "t5",
              ref: myWarehouseTitleRef,
              tabIndex: -1,
              "aria-live": "polite",
              children: myWarehouse
            }
          )
        ] }),
        /* @__PURE__ */ jsxs(NameAndDistanceAndLocation, { "data-testid": "warehousetile-nameanddistanceandlocation", children: [
          /* @__PURE__ */ jsx(LocationIconWrapper, { children: pinIndex !== void 0 ? /* @__PURE__ */ jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: renderWarehousePin({
                  number: pinIndex + 1,
                  weight: 300
                })
              },
              "data-testid": "warehousetile-location-pin"
            }
          ) : /* @__PURE__ */ jsx(
            Location,
            {
              sx: {
                height: "20px",
                width: "20px"
              },
              "data-testid": "warehousetile-location-icon"
            }
          ) }),
          /* @__PURE__ */ jsxs(NameAndDistance, { "data-testid": "warehousetile-nameanddistance", children: [
            /* @__PURE__ */ jsx(Link, { href: warehouseUrl, ref: warehouseNameRef, children: /* @__PURE__ */ jsx(
              Text,
              {
                sx: { display: "inline" },
                component: isPreferredWarehouse && !isFullPage ? "h5" : "h4",
                bold: true,
                underline: true,
                uniqueId: "warehousetile-nameanddistance-name",
                variant: "t5",
                children: warehouseName
              }
            ) }),
            (warehouseData == null ? void 0 : warehouseData.distance) && (warehouseData == null ? void 0 : warehouseData.distanceUnit) && /* @__PURE__ */ jsxs(
              Distance,
              {
                component: "span",
                uniqueId: "warehousetile-nameanddistance-distance",
                variant: "t6",
                children: [
                  "(",
                  (_e = warehouseData == null ? void 0 : warehouseData.distance) == null ? void 0 : _e.toFixed(2),
                  " ",
                  warehouseData == null ? void 0 : warehouseData.distanceUnit,
                  ")"
                ]
              }
            )
          ] })
        ] }),
        (warehouseData == null ? void 0 : warehouseData.stockStatus) && /* @__PURE__ */ jsx(
          StockStatus,
          {
            containerSx: { marginLeft: SpaceXl },
            ...getStockStatusProps(
              msStore,
              warehouseData.stockStatus,
              ((_f = warehouseData == null ? void 0 : warehouseData.regionCode) == null ? void 0 : _f.toLowerCase()) === IS_SHOWROOM_LOCATION,
              productFlags,
              featureFlags,
              warehouseData == null ? void 0 : warehouseData.timeZone
            )
          }
        ),
        (warehouseData == null ? void 0 : warehouseData.hours) && /* @__PURE__ */ jsx(
          OpeningHours,
          {
            entry: moduleSettings,
            holidays: warehouseData == null ? void 0 : warehouseData.holidays,
            hours: warehouseData == null ? void 0 : warehouseData.hours,
            sx: { marginLeft: SpaceXl },
            timeZone: warehouseData == null ? void 0 : warehouseData.timeZone,
            variant: "bodyCopy"
          }
        ),
        /* @__PURE__ */ jsxs(
          SeeWarehouseDetails,
          {
            "data-testid": "warehousetile-seewarehousedetails",
            disableGutters: true,
            expanded: isExpanded,
            isPreferredWarehouse,
            onChange: handleExpand,
            slotProps: {
              heading: {
                component: isPreferredWarehouse && !isFullPage ? "h6" : "h5"
              }
            },
            children: [
              /* @__PURE__ */ jsx(
                AccordionSummary,
                {
                  "aria-label": isExpanded ? `${hideWarehouseDetails} ${warehouseName}` : `${showWarehouseDetails} ${warehouseName}`,
                  component: "button",
                  "data-testid": "warehousetile-seewarehousedetails-icon-chevron-down",
                  expandIcon: /* @__PURE__ */ jsx(StyledChevronDown, {}),
                  onClick: onClickHandler,
                  sx: AccordianSummarySx,
                  children: isExpanded ? /* @__PURE__ */ jsx(Text, { uniqueId: "warehousetile-seewarehousedetails-hidden", children: hideWarehouseDetails }) : /* @__PURE__ */ jsx(Text, { uniqueId: "warehousetile-seewarehousedetails-show", children: showWarehouseDetails })
                }
              ),
              /* @__PURE__ */ jsxs(
                AccordionDetails,
                {
                  "data-testid": "warehousetile-seewarehousedetails-details",
                  sx: { padding: SpaceXs, paddingBottom: "0px" },
                  children: [
                    /* @__PURE__ */ jsxs(Box, { children: [
                      /* @__PURE__ */ jsx(Text, { uniqueId: "warehousetile-seewarehousedetails-address-line1", children: warehouseData == null ? void 0 : warehouseData.address.line1 }),
                      /* @__PURE__ */ jsxs(Text, { uniqueId: "warehousetile-seewarehousedetails-address-line2", children: [
                        capitalizeFirstLetter(warehouseData == null ? void 0 : warehouseData.address.city),
                        ", ",
                        warehouseData == null ? void 0 : warehouseData.address.territory,
                        " ",
                        warehouseData == null ? void 0 : warehouseData.address.postalCode
                      ] }),
                      showPhoneNumber && (!isMobile ? /* @__PURE__ */ jsx(Text, { uniqueId: UNIQUE_ID_MY_WAREHOUSE_PHONE, children: warehouseData == null ? void 0 : warehouseData.phone }) : /* @__PURE__ */ jsx(
                        Link,
                        {
                          href: `tel:${warehouseData == null ? void 0 : warehouseData.phone}`,
                          uniqueId: "warehousetile-seewarehousedetails-phone-link",
                          children: /* @__PURE__ */ jsx(
                            Text,
                            {
                              uniqueId: UNIQUE_ID_MY_WAREHOUSE_PHONE,
                              children: warehouseData == null ? void 0 : warehouseData.phone
                            }
                          )
                        }
                      )),
                      hasGas(warehouseData) && (warehouseData == null ? void 0 : warehouseData.gasPrices) && (hasRegularGasPrice(warehouseData) || hasPremiumGasPrice(warehouseData) || hasDieselGasPrice(warehouseData) || hasZeroEthanolGasPrice(warehouseData)) && /* @__PURE__ */ jsxs(Fragment, { children: [
                        /* @__PURE__ */ jsx(
                          Subheader,
                          {
                            color: "light",
                            uniqueId: "warehousetile-seewarehousedetails-gasprices",
                            variant: "t7",
                            children: gasPrices
                          }
                        ),
                        /* @__PURE__ */ jsxs(GasList, { children: [
                          hasRegularGasPrice(warehouseData) && /* @__PURE__ */ jsx(
                            GasPrice,
                            {
                              price: (_g = warehouseData == null ? void 0 : warehouseData.gasPrices) == null ? void 0 : _g.regular,
                              label: gasPriceRegular
                            }
                          ),
                          hasPremiumGasPrice(warehouseData) && /* @__PURE__ */ jsx(
                            GasPrice,
                            {
                              price: (_h = warehouseData == null ? void 0 : warehouseData.gasPrices) == null ? void 0 : _h.premium,
                              label: gasPricePremium
                            }
                          ),
                          hasDieselGasPrice(warehouseData) && /* @__PURE__ */ jsx(
                            GasPrice,
                            {
                              price: (_i = warehouseData == null ? void 0 : warehouseData.gasPrices) == null ? void 0 : _i.diesel,
                              label: gasPriceDiesel
                            }
                          ),
                          hasZeroEthanolGasPrice(
                            warehouseData
                          ) && /* @__PURE__ */ jsx(
                            GasPrice,
                            {
                              price: (_j = warehouseData == null ? void 0 : warehouseData.gasPrices) == null ? void 0 : _j.clear,
                              label: gasPriceZeroEthanol
                            }
                          )
                        ] })
                      ] }),
                      hasSupportedServices(warehouseData) && /* @__PURE__ */ jsxs(Fragment, { children: [
                        /* @__PURE__ */ jsx(
                          Subheader,
                          {
                            color: "light",
                            uniqueId: "warehousetile-seewarehousedetails-services",
                            variant: "t7",
                            children: services
                          }
                        ),
                        /* @__PURE__ */ jsxs(
                          Icons,
                          {
                            "data-testid": "warehousetile-seewarehousedetails-services-icons",
                            variant: "SimpleList",
                            children: [
                              hasGas(warehouseData) && /* @__PURE__ */ jsx(
                                ListItem,
                                {
                                  sx: listItemStyles,
                                  uniqueId: "gasitem",
                                  children: /* @__PURE__ */ jsx(
                                    Gas,
                                    {
                                      titleAccess: gasStation,
                                      sx: iconStyles,
                                      "data-testid": "gas"
                                    }
                                  )
                                }
                              ),
                              hasCarWash(warehouseData) && /* @__PURE__ */ jsx(
                                ListItem,
                                {
                                  sx: listItemStyles,
                                  uniqueId: "carwashitem",
                                  children: /* @__PURE__ */ jsx(
                                    CarWash,
                                    {
                                      titleAccess: carWash,
                                      sx: iconStyles,
                                      "data-testid": "carwash"
                                    }
                                  )
                                }
                              ),
                              hasTires(warehouseData) && /* @__PURE__ */ jsx(
                                ListItem,
                                {
                                  sx: listItemStyles,
                                  uniqueId: "tiresitem",
                                  children: /* @__PURE__ */ jsx(
                                    Tires,
                                    {
                                      titleAccess: tireCenter,
                                      sx: iconStyles,
                                      "data-testid": "tires"
                                    }
                                  )
                                }
                              ),
                              hasBusiness(warehouseData) && /* @__PURE__ */ jsx(
                                ListItem,
                                {
                                  sx: listItemStyles,
                                  uniqueId: "businesscenteritem",
                                  children: /* @__PURE__ */ jsx(
                                    Truck,
                                    {
                                      titleAccess: businessCenter,
                                      sx: iconStyles,
                                      "data-testid": "businesscenter"
                                    }
                                  )
                                }
                              ),
                              hasFood(warehouseData) && /* @__PURE__ */ jsx(
                                ListItem,
                                {
                                  sx: listItemStyles,
                                  uniqueId: "foodcourtitem",
                                  children: /* @__PURE__ */ jsx(
                                    FoodCourt,
                                    {
                                      titleAccess: foodCourt,
                                      sx: iconStyles,
                                      "data-testid": "foodcourt"
                                    }
                                  )
                                }
                              ),
                              hasHearing(warehouseData) && /* @__PURE__ */ jsx(
                                ListItem,
                                {
                                  sx: listItemStyles,
                                  uniqueId: "hearingaidsitem",
                                  children: /* @__PURE__ */ jsx(
                                    HearingAids,
                                    {
                                      titleAccess: hearingAids,
                                      sx: iconStyles,
                                      "data-testid": "hearingaids"
                                    }
                                  )
                                }
                              ),
                              hasOptical(warehouseData) && /* @__PURE__ */ jsx(
                                ListItem,
                                {
                                  sx: listItemStyles,
                                  uniqueId: "opticalitem",
                                  children: /* @__PURE__ */ jsx(
                                    Optical,
                                    {
                                      titleAccess: optical,
                                      sx: iconStyles,
                                      "data-testid": "optical"
                                    }
                                  )
                                }
                              ),
                              hasPharmacy(warehouseData) && /* @__PURE__ */ jsx(
                                ListItem,
                                {
                                  sx: listItemStyles,
                                  uniqueId: "parmacyitem",
                                  children: /* @__PURE__ */ jsx(
                                    Pharmacy,
                                    {
                                      titleAccess: pharmacy,
                                      sx: iconStyles,
                                      "data-testid": "pharmacy"
                                    }
                                  )
                                }
                              )
                            ]
                          }
                        )
                      ] }),
                      !hideScheduledHours && /* @__PURE__ */ jsx(
                        ScheduledHours,
                        {
                          businessHoursLabel,
                          closedHolidayLabel,
                          executiveMemberLabel,
                          executiveMemberHoursLabel,
                          hoursLabel: hours,
                          locale,
                          openHolidayLabel,
                          warehouseData,
                          sxHoursLabel: {
                            lineHeight: FontLineHeightMd
                          }
                        }
                      )
                    ] }),
                    /* @__PURE__ */ jsxs(
                      Box,
                      {
                        sx: {
                          display: "flex",
                          columnGap: SpaceMd,
                          marginTop: SpaceMd,
                          flexDirection: locale !== "fr-ca" ? "row" : "column"
                        },
                        children: [
                          /* @__PURE__ */ jsx(
                            Analytics,
                            {
                              analyticData: {
                                component: {
                                  trackedData: [
                                    getDirectionsLabel,
                                    warehouseName
                                  ]
                                }
                              },
                              children: /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsx(
                                Link,
                                {
                                  "aria-label": `${getDirectionsLabel} ${warehouseName}`,
                                  color: ColorTextDefault,
                                  href: getDirections(warehouseData),
                                  underline: "always",
                                  uniqueId: "warehousetile-seewarehousedetails-getdirections",
                                  target: "_blank",
                                  children: getDirectionsLabel
                                }
                              ) })
                            }
                          ),
                          /* @__PURE__ */ jsx(
                            Analytics,
                            {
                              analyticData: {
                                component: {
                                  trackedData: [viewStorePage, warehouseName]
                                }
                              },
                              children: /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsx(
                                Link,
                                {
                                  "aria-label": `${viewStorePage} ${warehouseName}`,
                                  color: ColorTextDefault,
                                  href: warehouseUrl,
                                  underline: "always",
                                  uniqueId: "warehousetile-seewarehousedetails-viewstorepage",
                                  children: viewStorePage
                                }
                              ) })
                            }
                          )
                        ]
                      }
                    )
                  ]
                }
              )
            ]
          }
        ),
        showSetWarehouseButton && /* @__PURE__ */ jsxs(
          Analytics,
          {
            analyticData: {
              component: {
                trackedData: [
                  setWarehouseButtonLabel,
                  warehouseName
                ]
              }
            },
            children: [
              /* @__PURE__ */ jsx(
                Button,
                {
                  sx: {
                    marginLeft: SpaceXl,
                    marginTop: SpaceXs
                  },
                  "aria-label": `${setWarehouseButtonLabel} ${warehouseName}`,
                  onClick: handleSetWarehouse,
                  uniqueId: "warehousetile-setwarehouse-as-preferred",
                  children: setWarehouseButtonLabel
                }
              ),
              hasError && /* @__PURE__ */ jsx(
                Notification,
                {
                  message: serviceErrorMessage,
                  severity: "alert",
                  sx: { marginLeft: SpaceXl, marginTop: SpaceXxs }
                }
              )
            ]
          }
        )
      ]
    }
  );
};
export {
  WarehouseTile
};
